import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

const NODE_STATES = {
  EMPTY: "EMPTY",
  COMPLETE: "COMPLETE",
  CURRENT: "CURRENT",
};

/**
 * JointDragDropRow:
 *  - A Row Component inside JOINT_GROUP  of DesignSection
 */
export function JointDragDropRow(props) {
  const onDropCard = (params) => {
    props.dropItem({
      nodeId: props.nodeId,
      positionID: params.positionId,
      componentID: params.optionID,
    });
  };

  const onRemoveCard = (positionID) => {
    props.removeItem({
      nodeId: props.nodeId,
      positionID,
    });
  };

  const renderComponent = (component, key) =>
    React.cloneElement(props.nodeHolder, {
      key: key,
      positionId: component.id,
      droppedId: component.droppedId,
      image: component.image,
      modal: component.modal,
      title: component.title,
      removeCard: onRemoveCard,
      dropItem: onDropCard,
      feedbackMessage: props.nodeFeedback[component.id],
    });

  const rowClass = () => {
    const nodeLength = props.nodeComponents.length;
    const classList = [
      "jointDragDropRow",
      `jointDragDropRow-${nodeLength}`,
      `jointDragDropRow-${props.nodeState.toLowerCase()}`,
    ];
    return classList.join(" ");
  };

  const wrapClass = () => {
    return props.nodeState === NODE_STATES.COMPLETE
      ? "jointRowWrap-complete"
      : "jointRowWrap";
  };

  if (props.nodeState === NODE_STATES.EMPTY) {
    return null;
  } else {
    return (
      <div className={wrapClass()}>
        <div className={rowClass()}>
          {props.nodeComponents.map(renderComponent)}
        </div>
      </div>
    );
  }
}

JointDragDropRow.propTypes = {
  /**
   * Unique Id for the node
   */
  nodeId: PropTypes.number.isRequired,
  /**
   * List Of components to be displayed in Row
   */
  nodeComponents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      droppedId: PropTypes.number,
      image: PropTypes.string,
      title: PropTypes.string,
      modal: PropTypes.object,
    })
  ).isRequired,
  /**
   * Function to invoke when a compooent is dropped in placeholder
   */
  dropItem: PropTypes.func,
  /**
   * Function to invoke when a component is removed
   */
  removeItem: PropTypes.func,
  /**
   * Object with error feedback message corrosponding to each Component
   */
  nodeFeedback: PropTypes.object.isRequired,
  /**
   * NodeHolder Component that will render placeholder and dropped component
   */
  nodeHolder: PropTypes.element.isRequired,
  /**
   * State of the Row. One of ['EMPTY','CURRENT', 'COMPLETE']
   */
  nodeState: PropTypes.oneOf(["EMPTY", "CURRENT", "COMPLETE"]).isRequired,
};

JointDragDropRow.defaultProps = {
  nodeState: NODE_STATES.EMPTY,
  nodeComponents: [],
};
